import React, { useState } from 'react';
import '../pages/About.css'
const FounderCard = ({ image, title, desc }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div 
      className='foundercard' 
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <img src={image} alt="Founder-img" />
      
      {isHovered && (
        <div className='found-hover-content'>
          <div className="founder-hover-card">
            <h3>{title}</h3>
            <p>{desc}</p>
            <button className='found-btn'>LinkedIN</button>

          </div>
          
        </div>
      )}
    </div>
  );
};

export default FounderCard;
